import matter from "gray-matter";

// Import markdown files - raw-loader is configured via CRACO
// eslint-disable-next-line import/no-webpack-loader-syntax
import post1Content from "!raw-loader!./posts/High-Performance-Browser-Networking.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import post2Content from "!raw-loader!./posts/Designing-Data-Intensive-Applications.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post3Content from "!raw-loader!./posts/The-Internet.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post4Content from "!raw-loader!./posts/Data-Structures-And-Algorithms.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import post5Content from "!raw-loader!./posts/Why-I-Developed-AccurateA.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post6Content from "!raw-loader!./posts/AI-Engineering.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post7Content from "!raw-loader!./posts/System-Design-Patterns.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post8Content from "!raw-loader!./posts/Backend-Developer-In-30-Days.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import post9Content from "!raw-loader!./posts/Learning-Go.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
import post10Content from "!raw-loader!./posts/Hands-On-Machine-LearningScikit-Learn-and-TensorFlow.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import post11Content from "!raw-loader!./posts/Python-For-DevOps.md";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import post12Content from "!raw-loader!./posts/Practical-MLOps.md";

// List of blog post metadata - add new posts here
// When adding a new post:
// 1. Create the .md file in ./posts/
// 2. Import it above: import newPost from "./posts/new-post.md";
// 3. Add it to this array: { slug: "new-post-slug", content: newPost }
const postMetadata = [
  {
    slug: "High-Performance-Browser-Networking",
    content: post1Content,
  },
  // {
  //   slug: "Designing-Data-Intensive-Applications",
  //   content: post2Content,
  // },
  {
    slug: "The-Internet",
    content: post3Content,
  },
  {
    slug: "Data-Structures-And-Algorithms",
    content: post4Content,
  },
  // {
  //   slug: "Why-I-Developed-AccurateA",
  //   content: post5Content,
  // },
  {
    slug: "AI-Engineering",
    content: post6Content,
  },
  {
    slug: "System-Design-Patterns",
    content: post7Content,
  },
  {
    slug: "Backend-Developer-In-30-Days",
    content: post8Content,
  },
  // {
  //   slug: "Learning-Go",
  //   content: post9Content,
  // },
  {
    slug: "Hands-On-Machine-LearningScikit-Learn-and-TensorFlow",
    content: post10Content,
  },
  // {
  //   slug: "Python-For-DevOps",
  //   content: post11Content,
  // },
  // {
  //   slug: "Practical-MLOps",
  //   content: post12Content,
  // },
];

// Parse posts with frontmatter
export const posts = postMetadata.map(({ slug, content }) => {
  const { data, content: markdownContent } = matter(content);

  return {
    slug: data.slug || slug,
    title: data.title || "Untitled",
    date: data.date || new Date().toISOString(),
    excerpt: data.excerpt || markdownContent.substring(0, 150) + "...",
    content: markdownContent,
    ...data, // Include any other frontmatter fields
  };
});

// Helper function to get a post by slug
export const getPostBySlug = (slug) => {
  return posts.find((post) => post.slug === slug);
};

// Helper function to get all posts sorted by date (newest first)
export const getAllPosts = () => {
  return [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
};
